import './UserFullName.scss';

const UserFullName = (props: { firstName: string; lastName: string }) => {
    return <span className='user-full-name'>{props.firstName} {props.lastName}</span>
}

export default UserFullName;